import { CollectionConfig } from "@rebasepro/types";

const contactMessagesCollection: CollectionConfig = {
    name: "Mensajes de contacto",
    singularName: "Mensaje de contacto",
    slug: "contact-messages",
    table: "contact_messages",
    securityRules: [
        {
            // `roles` are application roles read from auth.roles(); an
            // anonymous visitor holds none, so the old `roles: ["anon"]`
            // (a Supabase pgRole habit) compiled to a condition nobody could
            // satisfy and the public form's insert was denied.
            name: "public_insert",
            operation: "insert",
            access: "public"
        },
        {
            // Inbound contact form: write-only for the public form, readable by
            // staff. No end user has any reason to read other people's messages.
            name: "admin_full_access",
            operation: "all",
            roles: ["admin"]
        }
    ],
    properties: {
        id: {
            name: "ID",
            type: "string",
            isId: "uuid"
        },
        name: {
            name: "Nombre",
            type: "string",
            validation: {
                required: true
            }
        },
        email: {
            name: "Email",
            type: "string",
            validation: {
                required: true
            }
        },
        subject: {
            name: "Asunto",
            type: "string",
            validation: {
                required: true
            }
        },
        message: {
            name: "Mensaje",
            type: "string",
            admin: {
                multiline: true
            },
            validation: {
                required: true
            }
        },
        privacy_accepted: {
            name: "Privacidad aceptada",
            type: "boolean",
            validation: {
                required: true
            }
        },
        status: {
            name: "Estado",
            type: "string",
            enum: [
                { id: "new", label: "Sin leer", color: "blue" },
                { id: "read", label: "Leído", color: "orange" },
                { id: "replied", label: "Respondido", color: "green" }
            ],
            defaultValue: "new"
        },
        employer_key: {
            name: "Empresa a contactar",
            type: "string",
            description: "Se rellena si el mensaje se pasa a «Empresas que contratan». Los mensajes de candidatos y de reclutadores se quedan vacíos para siempre, que es lo correcto: no todo lo que entra es una empresa.",
            admin: { readOnly: true }
        },
        created_at: {
            name: "Creado",
            type: "date",
            autoValue: "on_create"
        }
    },
    admin: {
        group: "Captación",
        icon: "Mail",
        // Out of the menu since 2026-09-06, for the reason `company_leads`
        // gives: what arrives here is worked from "Empresas que contratan",
        // and in the collapsed drawer this shared its envelope with "Correo".
        hideFromNavigation: true,
        sort: ["created_at", "desc"],
        // The sender, what they wrote about, and the first words of it. Reading
        // the opening line is how you tell a real enquiry from the bot traffic
        // this form attracts — see the note on `filterPresets` below — and it
        // was the one thing the list did not show.
        display: {
            title: "name",
            subtitle: "message",
            status: "status",
            date: "created_at"
        },
        // `subject` and `message` are absent: the first is the subtitle's old
        // job and printed twice per row, the second is now the subtitle.
        listProperties: ["email", "subject", "status", "created_at"],
        previewProperties: ["name", "subject"],
        filterPresets: [
            {
                label: "Sin leer",
                filterValues: { status: ["==", "new"] }
            },
            {
                label: "Respondidos",
                filterValues: { status: ["==", "replied"] }
            }
        ]
    }
};

export default contactMessagesCollection;
